import { SecuredMessagingState } from '../../interfaces/SecuredMessagingState';
import {
  SelectAllMessages, SELECT_ALL_MESSAGES,
  SelectOneMessage, SELECT_ONE_MESSAGE,
  SetMessageRead, READ_MESSAGE, SecuredMessagingPageActions,
} from './SecuredMessagingPage.actions';

const securedMessagingPageReducer = (state: SecuredMessagingState, action: SecuredMessagingPageActions): SecuredMessagingState => {
  switch (action.type) {
    case SELECT_ALL_MESSAGES:
      return selectAllMessages(state, action);
    case SELECT_ONE_MESSAGE:
      return selectOneMessage(state, action);
    case READ_MESSAGE:
      return setMessageRead(state, action);
    default:
      return state;
  }
};

const selectAllMessages = (state: SecuredMessagingState, action: SelectAllMessages): SecuredMessagingState => {
  let ids: number[] = [];
  if (action.isChecked) {
    ids = state.messages.data.map((message) => message.id);
  }
  return {
    ...state,
    selectedMessages: ids,
  };
};

const selectOneMessage = (state: SecuredMessagingState, action: SelectOneMessage): SecuredMessagingState => {
  const selectedMessages = [...state.selectedMessages];
  const isAlreadyChecked = selectedMessages.includes(action.messageId);
  let ids: number[];

  if (isAlreadyChecked) {
    const index = selectedMessages?.findIndex((item) => item === action.messageId);
    selectedMessages.splice(index, 1);
    ids = selectedMessages;
  } else {
    ids = selectedMessages;
    ids.push(action.messageId);
  }

  return {
    ...state,
    selectedMessages: ids,
  };
};

const setMessageRead = (state: SecuredMessagingState, action: SetMessageRead): SecuredMessagingState => {
  const securedMessages = state.messages.data.map(
    (message) => message.id === action.messageId ? { ...message, isNew: false } : message,
  );
  return {
    ...state,
    messages: {
      ...state.messages,
      data: securedMessages,
    },
  };
};

export default securedMessagingPageReducer;
